import { GET_ARTICLES } from 'lib/queries';
import { useEffect, useState } from 'react';
import styled from 'styled-components';
import sanityGraphQLClient from 'utils/sanityGraphQLClient';

import { HorizontalScroll } from './HorizontalScroll';
import { LandscapeArticleCard } from './LanscapeArticleCard';

const StyledLatestArticles = styled.div`
  .header {
    & > h2 {
      font-size: 2.5rem;
      font-weight: 600;
    }
  }

  .item {
    min-width: 300px;

    &:not(:last-child) {
      margin-right: 1em;
    }
  }
`;

export const LatestArticles = () => {
  const [articles, setArticles] = useState([]);

  const fetchArticles = async () => {
    try {
      const response = await sanityGraphQLClient(GET_ARTICLES, {
        where: {},
        sort: [{ publishedAt: 'DESC' }],
        limit: 4,
        offset: 0
      });

      const results = response.allPost || [];

      setArticles(
        results.map((result) => {
          return {
            id: result._id,
            ...result
          };
        })
      );
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchArticles();
  }, []);

  return (
    <StyledLatestArticles>
      <HorizontalScroll
        title={
          <div className="header">
            <h2>Latest articles & events</h2>
          </div>
        }
        data={articles}
        render={(article) => <LandscapeArticleCard article={article} />}
        itemClassName="item"
      />
    </StyledLatestArticles>
  );
};
